<template>
  <span>{{ formatted }}</span>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";

const { appContext } = getCurrentInstance();

const props = defineProps({
  value: {
    type: [Number, String],
    default: 0
  }
});

const formatMoney = appContext.config.globalProperties.$formatMoney;

const formatted = computed(() => {
  return formatMoney(props.value ?? 0);
});
</script>
